import { render, staticRenderFns } from "./QuestionImageUploader.vue?vue&type=template&id=541822b1"
import script from "./QuestionImageUploader.vue?vue&type=script&lang=js"
export * from "./QuestionImageUploader.vue?vue&type=script&lang=js"
import style0 from "./QuestionImageUploader.vue?vue&type=style&index=0&id=541822b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports